import {Mapper} from '@s-ui/domain'

export class SeoAdsListSemanticCheapVansMetaConfigMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.log
   * */

  map = ({adsListSemanticConfig}) => {
    return adsListSemanticConfig.default
  }
}
